import {
  IconCloud as Cloud,
  IconDeviceMobile as Smartphone,
  IconWifiOff as WifiOff,
} from "@tabler/icons-react";
import { DEVICES_MOCKUP_URLS } from "../../constants/assets";

export function AvailableSection({ t, theme = "light" }) {
  const icons = [Smartphone, WifiOff, Cloud];
  const mockupUrl = theme === "dark" ? DEVICES_MOCKUP_URLS.dark : DEVICES_MOCKUP_URLS.light;

  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="container-x">
        <div className="rounded-[2rem] border border-[hsl(var(--border))] bg-[hsl(var(--surface-elevated))] overflow-hidden">
          <div className="grid gap-0 lg:grid-cols-12">
            <div className="lg:col-span-5 p-8 md:p-12 lg:p-16">
              <div className="reveal eyebrow mb-4">{t.available.eyebrow}</div>
              <h2 className="reveal font-display text-[clamp(1.75rem,3.5vw,3rem)] leading-[1.25] font-medium">
                {t.available.title}
              </h2>
              <p className="reveal mt-6 text-base md:text-lg text-muted-foreground leading-relaxed">
                {t.available.desc}
              </p>
              {/* <ul className="reveal mt-8 space-y-3">
                {t.available.bullets.map((b, i) => {
                  const Icon = icons[i];
                  return (
                    <li key={i} className="flex items-center gap-3">
                      <span className="grid h-8 w-8 place-items-center rounded-lg bg-brand-soft text-brand">
                        <Icon className="h-4 w-4" />
                      </span>
                      <span className="text-sm font-medium">{b}</span>
                    </li>
                  );
                })}
              </ul> */}
            </div>
            <div className="lg:col-span-7 relative bg-brand-deep p-4 md:p-6 lg:p-8 flex items-center justify-center min-h-[360px]">
              <div
                className="absolute inset-0 opacity-30"
                style={{
                  backgroundImage: "radial-gradient(circle at 50% 50%, hsl(var(--brand)) 0%, transparent 60%)",
                }}
              />
              <img
                src={mockupUrl}
                alt="Innospeq innospeq App auf Desktop und Mobile"
                className="reveal relative z-10 w-full max-w-full drop-shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
